import React, {useEffect, useState} from 'react'
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure()

const TollView = ({
                        match,
                        history,
                        locationState,
                        tollById,
                        tollView = []
                    }) => {

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            if (match?.params?.id !== undefined) {
                await tollById(match?.params?.id)
            }
            setIsLoading(false)
        })()
    }, [])



    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Fast Tag Toll'}
                            history={history}
                        />
                        {/*BODY*/}
                        <div>
                            <div className="container-fluid">
                                <form>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                            </div>
                                            <div className="mb-4 bg-white"> {/*card*/}
                                                <div className="hide card-header bg-lightGreen-active">
                                                    POC Details
                                                </div>
                                                <div className="card-body">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput(e.target.value, 'client_name', e)
                                                                       }}
                                                                       required
                                                                       value={tollView?.data?.client_name}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Toll Name <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput(e.target.value, 'fast_tag_toll_no', e)
                                                                       }}
                                                                       required
                                                                       value={tollView?.data?.account_type}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Type <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput(e.target.value, 'fast_tag_toll_no', e)
                                                                       }}
                                                                       required
                                                                       value={tollView?.data?.fast_tag_toll_no}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Toll No <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput(e.target.value, 'latitude', e)
                                                                       }}
                                                                       required
                                                                       value={tollView?.data?.state_name}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    State <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput(e.target.value, 'latitude', e)
                                                                       }}
                                                                       required
                                                                       value={tollView?.data?.city_name}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    City <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput(e.target.value, 'latitude', e)
                                                                       }}
                                                                       required
                                                                       value={tollView?.data?.latitude}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Latitude <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput(e.target.value, 'longitude', e)
                                                                       }}
                                                                       required
                                                                       disabled={true}
                                                                       value={tollView?.data?.longitude}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Longitude <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <img src={tollView?.data?.document} alt={""}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default TollView